export default function formatter(profile) {
  const { stylist } = profile

  const fetchRatingTarget = () => {
    if (!stylist.isStudioAccount) return stylist
    return stylist.studio
  }

  const ratingTarget = fetchRatingTarget()
  const rating = ratingTarget.rating || 0
  const totalRatingCount = ratingTarget.totalRatingCount || 0

  stylist.$rating = rating.toFixed(1)
  stylist.$ratingCount = totalRatingCount.format()
}
